import React, { useContext } from "react"
import { useHistory } from "react-router-dom"
import { AdditonalFeature } from "../../../pages/YourVehicle/AdditionalFeature/AdditionalFeature"
import { Registration } from "../../registration/Registration"
import { AppContext, AppContextInterface } from "../../../state/ContextProvider"
import { selectVehicleDetails } from "../../../state/selectors/vehicleDetails"
import { Button } from "../button/Button"
import { Mileage } from "../../mileage/Mileage"
import { VehicleCondition } from "../../vehicle-condition/VehicleCondition"

interface MileageProps {
  updateCondition?: boolean
  setUpdateCondition?: (arg0: boolean) => void
  setLoading?: (arg0: boolean) => void
}

const VehicleInfoContainer: React.FC<MileageProps> = ({
  updateCondition,
  setUpdateCondition,
  setLoading,
}) => {
  const {
    state: { vehicleDetails, vehicleCondition, mileage },
    actions: { addVehicleCondition, addValuation },
    api: { getValuationWithoutLead },
  } = useContext(AppContext) as AppContextInterface

  const history = useHistory()

  const formattedVehicleDetails = selectVehicleDetails(vehicleDetails)

  const {
    makeAndModel,
    derivative,
    previousOwners,
    additionalFeatures,
    defaultCapImageUrl,
  } = formattedVehicleDetails as any

  const element = (e: any) => {
    return e.target as HTMLElement
  }

  const filteredFeatures = additionalFeatures?.filter(
    (feature: any) => feature !== ""
  )

  return (
    <div className="vehicle-info-container">
      <div className="your-vehicle-page container">
        <div className="column info">
          <div className="your-vehicle-container">
            <div className="vehicle-info">
              <Registration />
              <div className="details">
                <h2>{makeAndModel}</h2>
                <p className="derivative">{derivative}</p>
                <p className="climate-controls">{previousOwners}</p>
                <div className="feature-container">
                  {filteredFeatures?.map((feature: string) => (
                    <AdditonalFeature key={feature} feature={feature} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="column image">
          <div className="vehicle-image vehicle-info-container">
            {defaultCapImageUrl ? (
              <>
                <img
                  alt={makeAndModel}
                  src={defaultCapImageUrl}
                  onError={(e) => (element(e).style.display = "none")}
                />
                <p className="image-paragraph">
                  Image for illustration purposes only
                </p>
              </>
            ) : null}{" "}
          </div>
        </div>
      </div>
      {setUpdateCondition ? (
        <button
          className="condition-container"
          onClick={() => setUpdateCondition(!updateCondition)}
        >
          <span className="condition-wrapper">
            <span className="conditions">
              <span className="condition">Condition: {vehicleCondition}</span>
              <span className="condition">Mileage: {mileage}</span>
            </span>
            <span className="change-link">
              <span className="inner-change-link-span">Change</span></span>
          </span>
        </button>
      ) : null}
      {setUpdateCondition && updateCondition ? (
        <div className="edit-vehicle-info-container">
          <Mileage
            mileage={mileage}
            text={"Mileage"}
            shouldRenderButton={false}
          />
          <VehicleCondition
            vehicleCondition={vehicleCondition}
            addVehicleCondition={addVehicleCondition}
            rendersAdditionalText={false}
          />
          <div className="condition-button-wrapper">
            <Button
              onClick={() => {
                addValuation(undefined)
                getValuationWithoutLead(history)
                setLoading && setLoading(true)
                setUpdateCondition(false)
                window.scrollTo(0, 0)
              }}
              className="no-arrow"
              variant="blue"
            >
              Confirm
            </Button>
            <Button
              onClick={() => {
                setUpdateCondition(false)
                window.scrollTo(0, 0)
              }}
              variant="white"
            >
              Cancel
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default VehicleInfoContainer
